
import { gql } from '@apollo/client'

const deleteBucketVersionMutation = gql(`
  mutation deleteBucketVersion($id: ID, $bucketId: ID)
  {
    deleteBucketVersion(id: $id, bucketId:$bucketId){
      id
    }
  }
`)

export default deleteBucketVersionMutation
